module.exports = __webpack_public_path__ + "img/18290211000171.bf804a3c.png";